import { Fragment } from "react";
import { GetImages } from "../../../utils/GetImages";
import { AccessLevel, ROLE_ACCESS_ROWS, ROLE_COLUMNS } from "./roleAccessMatrixData";
import "./RoleAccessMatrix.css";

const ACCESS_LEVEL_TO_ICON: Record<AccessLevel, { icon: string; label: string }> = {
  full: { icon: GetImages.CheckGreenIcon, label: "Full access" },
  read: { icon: GetImages.OpenEyeIconBlue, label: "Read-only access" },
  none: { icon: GetImages.greycross, label: "No access" },
};

const RoleAccessMatrix = () => {
  const groups: string[] = [];
  ROLE_ACCESS_ROWS.forEach((row) => {
    if (groups[groups.length - 1] !== row.group) {
      groups.push(row.group);
    }
  });

  return (
    <div className="role-access-matrix-container">
      <p className="heading black role-access-matrix-title">What each role can access</p>
      <p className="sub_text role-access-matrix-subtitle">
        Full access, read-only access, or no access at all, module by module.
      </p>

      <div className="role-access-matrix-legend">
        {(Object.keys(ACCESS_LEVEL_TO_ICON) as AccessLevel[]).map((level) => {
          const access = ACCESS_LEVEL_TO_ICON[level];
          return (
            <div className="role-access-matrix-legend-item" key={level}>
              <img src={access.icon} alt="" className="Icon20" />
              <span>{access.label}</span>
            </div>
          );
        })}
      </div>

      <div className="role-access-matrix-scroll">
        <table className="role-access-matrix">
          <thead className="role-access-matrix-thead">
            <tr>
              <th className="role-access-matrix-module-col">Module</th>
              {ROLE_COLUMNS.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {groups.map((group) => (
              <Fragment key={group}>
                <tr className="role-access-matrix-group-row">
                  <th colSpan={ROLE_COLUMNS.length + 1}>{group}</th>
                </tr>
                {ROLE_ACCESS_ROWS.filter((row) => row.group === group).map((row) => (
                  <tr key={row.module}>
                    <th className="role-access-matrix-module-col">{row.module}</th>
                    {ROLE_COLUMNS.map((col) => {
                      const access = ACCESS_LEVEL_TO_ICON[row[col.key]];
                      return (
                        <td key={col.key}>
                          <img src={access.icon} alt={access.label} title={access.label} className="Icon20" />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoleAccessMatrix;
